export const EMAIL_LIMIT_PER_ROLLING_24H = 300; // for testing purposes, TODO: remove before merge
// export const EMAIL_LIMIT_PER_ROLLING_24H = 300;
